export default "__VITE_PUBLIC_ASSET__171d9524__"